 
(function () {
  var map = null;

  function colorIndex(p) {
    for (var i = 0; i < p.options.length; i++) {
      var n = typeof p.options[i] === "string" ? p.options[i] : p.options[i].name;
      if (/colou?r/i.test(n)) return i;
    }
    return -1;
  }

  function build(cb) {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    fetch("/products/" + m[1] + ".js")
      .then(function (r) { return r.json(); })
      .then(function (p) {
        map = {};
        var oi = colorIndex(p);
        if (oi >= 0) {
          p.variants.forEach(function (v) {
            var col = v["option" + (oi + 1)];
            if (col && !map[col] && v.featured_image) map[col] = v.featured_image.src;
          });
        }
        cb();
      })
      .catch(function () {});
  }

  function thumbUrl(src) {
    return src + (src.indexOf("?") >= 0 ? "&" : "?") + "width=96";
  }

  function updateLegend(fieldset) {
    var legend = fieldset.querySelector("legend");
    var checked = fieldset.querySelector("input[type=radio]:checked");
    if (!legend || !checked) return;
    if (!legend.dataset.ccBase) legend.dataset.ccBase = legend.textContent.trim();
    var next = legend.dataset.ccBase + " — " + checked.value;

    if (legend.textContent !== next) legend.textContent = next;
  }

  function paint() {
    if (!map) return;
    document.querySelectorAll(".variant-option__button-label").forEach(function (l) {
      var input = l.querySelector("input[type=radio]");
      var t = (input ? input.value : l.textContent).trim();
      var s = map[t];
      if (!s || l.querySelector(".cc-thumb")) return;
      var img = document.createElement("img");
      img.className = "cc-thumb";
      img.alt = "";
      img.decoding = "async";
      img.src = thumbUrl(s);
      l.insertBefore(img, l.firstChild);
      l.classList.add("cc-has-thumb");
      l.title = t;
      var fs = l.closest("fieldset");
      if (fs && !fs.classList.contains("cc-swatch-fieldset")) {
        fs.classList.add("cc-swatch-fieldset");
        fs.addEventListener("change", function () { updateLegend(fs); });
        updateLegend(fs);
      }
    });
    document.querySelectorAll(".cc-swatch-fieldset").forEach(updateLegend);
  }

  function start() {
    build(function () {
      paint();
      [250, 750, 1500, 3000].forEach(function (ms) { setTimeout(paint, ms); });
      var picker =
        document.querySelector("variant-picker") ||
        document.querySelector('form[action*="/cart/add"]') ||
        document.body;
      try {
        new MutationObserver(paint).observe(picker, { childList: true, subtree: true });
      } catch (e) {}
    });
  }

  if (document.readyState !== "loading") start();
  else document.addEventListener("DOMContentLoaded", start);
})();
